import { Injectable, ChangeDetectorRef } from '@angular/core';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root',
  })
export class Session {

    constructor(private router: Router){
    }

    user;

   showDrawer = true;

   zonas = [];

   tecnicos = [];

   tickets = [];

   repuestos = [];
   productos = [];

   provincias = ["Buenos Aires",
   "Catamarca",
   "Capital Federal",
   "Chaco",
   "Chubut",
   "Cordoba",
   "Corrientes",
   "Entre Rios",
   "Formosa",
   "Jujuy",
   "La Pampa",
   "La Rioja",
   "Mendoza",
   "Misiones",
   "Neuquen",
   "Rio Negro",
   "Salta",
   "San Juan",
   "San Luis",
   "Santa Cruz",
   "Santa Fe",
   "Santiago del Estero",
   "Tierra del Fuego",
   "Tucuman",];

   logout(){
    this.user = null;
    this.router.navigate(['login']);
   }

   feriados = [ "21/08/1990","22/08/1990"];



   assignTicketError;
   assignTicket(ticket){
     
      this.assignTicketError = null;
      let ticket_existente = this.tickets.find( t => t.garantia === ticket.garantia  && (t.status == "NEW" || t.status == "EN CURSO"));
      if(ticket_existente){ 
        this.assignTicketError = "Ya existe un reclamo abierto para ese nro de Garantía";
        return false;
      }
      if(this.feriados.indexOf(ticket.fecha)>=0){
        this.assignTicketError = "No se puede generar un reclamo un día feriado";
         return false;
      }


      var posibles_tecnicos = [];
      let zonaPretendida = ticket.zona.provincia+":"+ticket.zona.localidad;
      for(let t of this.tecnicos){
        let i = t.zonas.findIndex(x=> x.nombre === zonaPretendida);
        if(i>=0) posibles_tecnicos.push(t);
      }
      if(posibles_tecnicos.length==0) return false;

      var id_tecnico_con_menos_tickets_para_esa_fecha;
      var cantidad_de_tickets_del_tecnico_candidato = -1;
      for(let t of posibles_tecnicos){
        let assignations = t.assignations.find(x=>x.fecha == ticket.fecha);
        
        if(!assignations){
          //El primer tecnico sin asignaciones esa fecha es el candidato
          let tecnico_final = this.tecnicos.find(x=>x.id == t.id);
          tecnico_final.assignations.push({ fecha: ticket.fecha, tickets: [ticket]});
          ticket.tecnico_asignado = { id: tecnico_final.id, nombre: tecnico_final.nombre, apellido: tecnico_final.apellido};
          ticket.id = (new Date()).getTime();
          this.tickets.push(ticket);
          return true;
        }
        if(assignations.tickets.length>=t.max_tickets) continue;
        if(!id_tecnico_con_menos_tickets_para_esa_fecha){
          id_tecnico_con_menos_tickets_para_esa_fecha = t.id;
          cantidad_de_tickets_del_tecnico_candidato = assignations.tickets.length;
        } 
        else{
          if(assignations.tickets.length<cantidad_de_tickets_del_tecnico_candidato){
            id_tecnico_con_menos_tickets_para_esa_fecha = t.id;
            cantidad_de_tickets_del_tecnico_candidato = assignations.tickets.length;
          }
        }
      }
      if(id_tecnico_con_menos_tickets_para_esa_fecha){
        let tecnico_final = this.tecnicos.find(x=>x.id == id_tecnico_con_menos_tickets_para_esa_fecha);
        tecnico_final.assignations.find(x=> x.fecha == ticket.fecha).tickets.push(ticket);
        ticket.tecnico_asignado = { id: tecnico_final.id, nombre: tecnico_final.nombre, apellido: tecnico_final.apellido};
        ticket.id = (new Date()).getTime();
        this.tickets.push(ticket);
        return true;
      }
      
      return false;
   }

   reasignarError = "";
   reasignar(ticket, id_tecnico){
     this.reasignarError = "";
    if(ticket.tecnico_asignado.id == id_tecnico){
      this.reasignarError = "El técnico a reasignar es el mismo que esta asigando al ticket";
      return false;
    }
    var tecnico_asignado = this.tecnicos.find(x=> x.id == ticket.tecnico_asignado.id);
    var tecnico_a_asignar = this.tecnicos.find(x=> x.id == id_tecnico);
    var asignaciones_para_el_dia_del_tecnico_a_asignar = tecnico_a_asignar.assignations.find(x=> x.fecha== ticket.fecha)
    // if(tecnico_a_asignar.max_tickets<=tecnico_a_asignar.assignations.find()){}
   }

   persist(){
     localStorage.setItem("tickets", JSON.stringify(this.tickets));
     localStorage.setItem("tecnicos", JSON.stringify(this.tecnicos));
     localStorage.setItem("zonas", JSON.stringify(this.zonas));

   }

   load(){

     if(localStorage.getItem("tickets"))this.tickets = JSON.parse(localStorage.getItem("tickets"));
     if(localStorage.getItem("tecnicos"))this.tecnicos = JSON.parse(localStorage.getItem("tecnicos"));
     if(localStorage.getItem("zonas"))this.zonas = JSON.parse(localStorage.getItem("zonas"));

   }
}
